var chunkToChildrenMap = {
	"116": [
		6939
	],
	"1815": [
		1574
	],
	"2423": [
		8295
	],
	"3368": [
		8530
	],
	"3867": [
		3121
	],
	"7157": [
		8530,
		9862
	],
	"8665": [
		6297
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));